<template>
  <section class="app-modal__section payment-plan-pay-modal__section--plan-overview" :class="{ 'payment-plan-pay-modal__section--plan-overview-cfdi': isCfdiMode }">
    <div class="payment-plan-pay-modal__plan-card">
      <div
        class="payment-plan-pay-modal__plan-card-grid payment-plan-pay-modal__plan-card-grid--compact"
        :class="{ 'payment-plan-pay-modal__plan-card-grid--cfdi-inline': isCfdiMode }"
      >
        <div class="payment-plan-pay-modal__readonly-item">
          <span>{{ text.payModal.planCard.fields.customer }}</span>
          <strong>{{ planCustomer }}</strong>
        </div>

        <div class="payment-plan-pay-modal__readonly-item">
          <span>{{ text.payModal.planCard.fields.voucherType }}</span>
          <strong>{{ planVoucherTypeLabel }}</strong>
        </div>

        <div class="payment-plan-pay-modal__readonly-item">
          <span>{{ text.payModal.planCard.fields.scheduledDate }}</span>
          <strong>{{ formatDateShortMonth(planDate) }}</strong>
        </div>

        <div v-if="isCfdiMode" class="payment-plan-pay-modal__readonly-item">
          <span>{{ text.payModal.planCard.fields.paymentMethod }}</span>
          <strong>{{ planInvoicePaymentMethod }}</strong>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PayModalSectionPlan',
  props: {
    text: {
      type: Object,
      required: true,
    },
    isCfdiMode: {
      type: Boolean,
      default: false,
    },
    planCustomer: {
      type: String,
      default: '-',
    },
    planVoucherTypeLabel: {
      type: String,
      default: '-',
    },
    planDate: {
      type: String,
      default: '',
    },
    planInvoicePaymentMethod: {
      type: String,
      default: '-',
    },
    formatDateShortMonth: {
      type: Function,
      required: true,
    },
  },
};
</script>
